export const SORT_OPTIONS = [
    {label: 'None', value: ''},
    {label: 'Customer Reviews (High → Low)', value: 'customerReviewCount.desc'},
    {label: 'Percent Savings (High → Low)', value: 'percentSavings.desc'},
    {label: 'Price (Low → High)', value: 'salePrice.asc'},
    {label: 'Price (High → Low)', value: 'salePrice.desc'},
];